module.exports = __webpack_public_path__ + "static/img/mm.81f75fdb.webp";